import { apply } from '../diff/apply.js';
import { diff } from '../diff/diff.js';
import { merge } from '../diff/merge.js';
export { diff, apply, merge };
